import type { IObjectiveRepaymentType } from './ObjectiveRepaymentType.interface';
import ObjectiveTypeBase from './ObjectiveTypeBase';

export default class ObjectiveRepaymentType implements IObjectiveRepaymentType {
  principalAndInterest: ObjectiveTypeBase;
  interestOnly: ObjectiveTypeBase;
  interestInAdvance: ObjectiveTypeBase;
  lineOfCredit: ObjectiveTypeBase;

  static build = (data: IObjectiveRepaymentType) => new ObjectiveRepaymentType(data);
  static blank = () => new ObjectiveRepaymentType();

  /**
   * Constructor
   * @param {IObjectiveRepaymentType} data
   */
  constructor(data?: IObjectiveRepaymentType) {
    this.principalAndInterest = new ObjectiveTypeBase(data?.principalAndInterest);
    this.interestOnly = new ObjectiveTypeBase(data?.interestOnly, 'interestOnly');
    this.interestInAdvance = new ObjectiveTypeBase(data?.interestInAdvance);
    this.lineOfCredit = new ObjectiveTypeBase(data?.lineOfCredit);
  }
}
